import React from 'react';
import { Modal, message, Button, Popconfirm, Icon, Tooltip } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

class MoreCrcHandover extends React.Component {
    state = {
        visible: false,
        loading: false,
        list: [],
    }

    show = (list) => {
        this.setState({
            visible: true,
            list,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible, loading, list } = this.state;
        return (
            <div>
                <Modal
                    title="进行中的CRC交接记录"
                    visible={visible}
                    onCancel={this.hide}
                    className="create-modal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="800px"
                    loading={loading}
                    footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
                >
                    {
                        list.length ?
                            <div>
                                {
                                    list.map((el, index) => 
                                        <div className='backlogli'>
                                            <Tooltip title={el.noticeInfo} overlayStyle={{ maxWidth: 350 }}>
                                                <div className='left' style={{color: el.readStatus !== 'READ' ? '#5750b7': 'rgba(0,0,0,0.6)'}} onClick={() => this.props.clickNotice(null, el, index)}>
                                                    {`[${el.noticeTypeValue}] ${el.noticeInfo}`}
                                                </div>    
                                            </Tooltip>
                                            <div className='right'>
                                                <Popconfirm title='确定标记此待办事项已处理吗?' 
                                                    onConfirm={() => this.props.confirmNoticeReadByOne(el.noticeId)} 
                                                    okText="确定" 
                                                    cancelText="取消"
                                                >
                                                    <a>标记为已处理</a>
                                                </Popconfirm>
                                                <br />
                                                <span style={{color:'#cccccc'}}>{moment(el.createTime).format('YYYY-MM-DD')}</span>
                                            </div>
                                        </div>
                                    )
                                }
                                <div className='data_null'>
                                    {
                                        list.length == 0 && <span><i className='anticon anticon-frown-o'></i>暂无数据</span>
                                    }
                                </div>
                            </div>
                        :
                            null
                    }
                </Modal>
            </div>
        );
    }
}

export default MoreCrcHandover;


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/MoreCrcHandover.js